(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/helpers/dialogs.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/helpers/dialogs.js');
'use strict';

const {
  removeUrlAfterPayServerAsync
} = svs.playerRegistration.helpers;
const showTechnicalError = function () {
  let title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Tekniskt fel';
  let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Något gick fel. Prova gärna igen om en stund.';
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showCantBecomeACustomer = () => showTechnicalError('Hej', "Du kan inte \xE5teraktivera dig.</br> Vid fr\xE5gor, kontakta\n          <a href=".concat(svs.core.urlMapping.get('customerServiceContact'), ">Svenska Spels kundservice</a>."));
const showHandleDoItLaterDialog = (betProduct, returnUrl) => {
  const capitalizeString = svs.utils.format.capitalize;
  const dialogText = betProduct ? "F\xF6r att kunna betala ditt ".concat(capitalizeString(betProduct, true), "-spel beh\xF6ver du f\xF6rst best\xE4mma hur mycket du vill kunna s\xE4tta in per m\xE5nad, vecka och dag.") : 'För att kunna spela behöver du först bestämma hur mycket du vill kunna sätta in per månad, vecka och dag.';
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'help',
    branding: svs.ui.dialog.branding.TUR,
    title: 'Är du säker på att du inte vill sätta dina gränser nu?',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: dialogText
    }],
    allowDimmerClick: false,
    actions: [{
      title: 'Tillbaka',
      callback: () => {
        dialog.close();
      }
    }, {
      title: 'Gör senare',
      callback: async () => {
        var _svs, _svs$clearExtraData;
        await removeUrlAfterPayServerAsync();
        await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$clearExtraData = _svs.clearExtraData) === null || _svs$clearExtraData === void 0 ? void 0 : _svs$clearExtraData.call(_svs));
        dialog.close();
        svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('startPage')));
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const showHandleDoItLaterNewDesignDialog = (betProduct, returnUrl) => {
  const capitalizeString = svs.utils.format.capitalize;
  const dialogBaseText = betProduct ? "<p>F\xF6r att kunna betala ditt ".concat(capitalizeString(betProduct, true), "-spel beh\xF6ver du s\xE4tta gr\xE4nser.</p>") : "<p>F\xF6r att kunna betala ditt spel beh\xF6ver du s\xE4tta gr\xE4nser</p>";
  const customerServicePhone = '0770111111';
  const customerServiceText = "<p>Har du fr\xE5gor? <a class=\"\" href=\"tel:\"".concat(customerServicePhone, "\">Kontakta Kundservice</a></p>");
  const dialogText = dialogBaseText + customerServiceText;
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'loss-limit',
    branding: svs.ui.dialog.branding.TUR,
    title: 'Är du säker på att du vill avbryta?',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: dialogText
    }],
    allowDimmerClick: false,
    actions: [{
      title: 'Avbryt',
      callback: () => {
        dialog.close();
      }
    }, {
      title: 'Fortsätt',
      callback: async () => {
        var _svs2, _svs2$clearExtraData;
        await removeUrlAfterPayServerAsync();
        await ((_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.accountservices) === null || _svs2 === void 0 || (_svs2 = _svs2.onboardingHandler) === null || _svs2 === void 0 || (_svs2$clearExtraData = _svs2.clearExtraData) === null || _svs2$clearExtraData === void 0 ? void 0 : _svs2$clearExtraData.call(_svs2));
        dialog.close();
        svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('startPage')));
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const showDoDepositLaterDialog = (betProduct, callback, cancelCallback) => {
  const dialogTitle = "F\xF6r att kunna betala ditt p\xE5b\xF6rjade ".concat(betProduct, "-spel beh\xF6ver du g\xF6ra en ins\xE4ttning.");
  const dialogText = 'Är du säker på att du inte vill göra det nu?';
  svs.playerRegistration.logger.debug('Do it later setting limit dialog');
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'help-2',
    branding: svs.ui.dialog.branding.TUR,
    title: dialogTitle,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: dialogText
    }],
    allowDimmerClick: false,
    actions: [{
      title: 'Tillbaka',
      callback: () => {
        dialog.close();
        typeof cancelCallback === 'function' && cancelCallback();
      }
    }, {
      title: 'Jag gör det senare',
      showLoader: true,
      callback: async () => {
        var _svs3, _svs3$clearExtraData;
        await removeUrlAfterPayServerAsync();
        await ((_svs3 = svs) === null || _svs3 === void 0 || (_svs3 = _svs3.accountservices) === null || _svs3 === void 0 || (_svs3 = _svs3.onboardingHandler) === null || _svs3 === void 0 || (_svs3$clearExtraData = _svs3.clearExtraData) === null || _svs3$clearExtraData === void 0 ? void 0 : _svs3$clearExtraData.call(_svs3));
        if (callback) {
          callback();
        }
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const showHowWeUseInfoDialog = () => {
  const emailBulletList = "\n  <ul class=\"align-left register-dialog-ul\">\n    <li>Information som r\xF6r ditt avtal</li>\n    <li>N\xE4r du har vunnit och n\xE4r ditt flerveckorsspel tagit slut</li>\n    <li>\xD6vrig information och erbjudanden (direktmarknadsf\xF6ring)</li>\n    <li>Kontakta dig vid behov, t.ex. av legala sk\xE4l</li>\n  </ul>\n  ";
  const mobileBulletList = "\n  <ul class=\"align-left register-dialog-ul\">\n    <li>Kunna ringa dig vid st\xF6rre vinst</li>\n    <li>F\xF6ra \xF6ver pengar genom en betaltj\xE4nst</li>\n    <li>Kunna skicka information och erbjudanden via sms (direktmarknadsf\xF6ring)</li>\n    <li>Kontakta dig vid behov, t.ex. av legala sk\xE4l</li>\n  </ul>\n  ";
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'information',
    branding: svs.ui.dialog.branding.TUR,
    title: 'Så använder vi dina kontaktuppgifter',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: "Vi anv\xE4nder din e-post f\xF6r att:\n        <br/>\n        ".concat(emailBulletList)
    }, {
      type: svs.ui.dialog.message.TEXT,
      text: "Vi anv\xE4nder ditt mobilnummer f\xF6r att:\n        <br/>\n        ".concat(mobileBulletList)
    }, {
      type: svs.ui.dialog.message.TEXT,
      text: 'Du kan hantera dina kontaktuppgifter och val för direktmarknadsföring under Min profil.'
    }],
    allowDimmerClick: true,
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const showTechnicalKycError = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Tekniskt fel',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Vi kunde inte spara dina svar just nu. Vänligen försök igen senare. När frågorna är besvarade får du tillgång till ditt spelkonto.'
    }],
    actions: [{
      title: 'Okej',
      callback: () => resolve()
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showExpiredIdentificationDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: 'Inaktivitetsmeddelande',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Din BankID identifiering har gått ut. Identifiera dig på nytt för att fortsätta.'
    }],
    actions: [{
      title: 'Identifiera',
      callback: () => {
        svs.utils.url.navigate(svs.core.urlMapping.get('customerRegistrationHome'));
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};

const showLimitWarningDialog = (title, message, continueButtonText, cancelButtonText) => new Promise(resolve => {
  const {
    dialog: dialogComp
  } = svs.ui;
  const dialog = new dialogComp.Confirm({
    branding: dialogComp.branding.TUR,
    icon: 'exclamation-sign',
    area: dialogComp.area.POPUP,
    type: dialogComp.type.INFO,
    title,
    message: [{
      type: dialogComp.message.TEXT,
      text: message,
      align: dialogComp.message.align.CENTER
    }],
    actions: [{
      title: continueButtonText,
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }, {
      title: cancelButtonText,
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }]
  });
  dialogComp.api.add(dialog);
});
svs.playerRegistration.dialogs = {
  showTechnicalError,
  showCantBecomeACustomer,
  showHandleDoItLaterDialog,
  showHandleDoItLaterNewDesignDialog,
  showDoDepositLaterDialog,
  showHowWeUseInfoDialog,
  showTechnicalKycError,
  showExpiredIdentificationDialog,
  showLimitWarningDialog
};

 })(window);